import { Action } from '@ngrx/store';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import { IApiAutomationQueryParams } from '../shared/api-automation.model';
import {
  IBurstSetting,
  IBurstSettingRow,
} from '../../../../view/settings/api-automation-settings/burst-settings/burst-settings.model';
import { LineCRUDInterface } from '../../../../shared/component/filter/filter.class';
import { SimplifiedDataInterface } from '../../tasks/tasks.model';
import { SiteCRUDInterface } from '../../../../shared/component/filter/filter.class';

export enum ActionTypes {
  BURST_SETTINGS_DATA_LOADING = '[BURST_SETTINGS] BURST_SETTINGS DATA LOADING',
  BURST_SETTINGS_DATA_LOADED = '[BURST_SETTINGS] BURST_SETTINGS DATA LOADED',
  GET_BURST_SETTING = '[BURST_SETTINGS] GET_BURST_SETTING LOADING',
  GET_BURST_SETTING_COMPLETED = '[BURST_SETTINGS] GET_BURST_SETTING COMPLETED',
  ADD_BURST_SETTING = '[BURST_SETTINGS] ADD_BURST_SETTING',
  ADD_BURST_SETTING_COMPLETED = '[BURST_SETTINGS] ADD_BURST_SETTING COMPLETED',
  EDIT_BURST_SETTING = '[BURST_SETTINGS] EDIT_BURST_SETTING',
  EDIT_BURST_SETTING_COMPLETED = '[BURST_SETTINGS] EDIT_BURST_SETTING COMPLETED',
  DELETE_BURST_SETTINGS = '[BURST_SETTINGS] DELETE_BURST_SETTINGS',
  DELETE_BURST_SETTINGS_COMPLETED = '[BURST_SETTINGS] DELETE_BURST_SETTINGS COMPLETED',
  SITES_DATA_LOADING = '[BURST_SETTINGS] SITES DATA LOADING',
  SITES_DATA_COMPLETED = '[BURST_SETTINGS] SITES DATA COMPLETED',
  LINES_DATA_LOADING = '[BURST_SETTINGS] LINES DATA LOADING',
  LINES_DATA_COMPLETED = '[BURST_SETTINGS] LINES DATA COMPLETED',
  ALL_LINES_DATA_LOADING = '[BURST_SETTINGS] ALL_LINES DATA LOADING',
  ALL_LINES_DATA_COMPLETED = '[BURST_SETTINGS] ALL_LINES DATA COMPLETED',
  FETCH_ERROR = '[BURST_SETTINGS] FETCH ERROR',
}

export class BurstSettingsLoading implements Action {
  readonly type = ActionTypes.BURST_SETTINGS_DATA_LOADING;

  constructor(public params: IApiAutomationQueryParams) {}
}

export class BurstSettingsLoaded implements Action {
  readonly type = ActionTypes.BURST_SETTINGS_DATA_LOADED;

  constructor(public payload: GetManyResponseInterface<IBurstSetting>) {}
}

export class GetBurstSetting implements Action {
  readonly type = ActionTypes.GET_BURST_SETTING;

  constructor(public recordId: number) {}
}

export class GetBurstSettingCompleted implements Action {
  readonly type = ActionTypes.GET_BURST_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IBurstSetting>) {}
}
export class AddBurstSetting implements Action {
  readonly type = ActionTypes.ADD_BURST_SETTING;

  constructor(
    public record: IBurstSettingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class AddBurstSettingCompleted implements Action {
  readonly type = ActionTypes.ADD_BURST_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IBurstSetting>) {}
}
export class EditBurstSetting implements Action {
  readonly type = ActionTypes.EDIT_BURST_SETTING;

  constructor(
    public recordId: number,
    public record: IBurstSettingRow,
    public hideLoaderAfterSuccess: boolean = true,
  ) {}
}

export class EditBurstSettingCompleted implements Action {
  readonly type = ActionTypes.EDIT_BURST_SETTING_COMPLETED;

  constructor(public payload: BaseOneResponseInterface<IBurstSetting>) {}
}
export class DeleteBurstSettings implements Action {
  readonly type = ActionTypes.DELETE_BURST_SETTINGS;

  constructor(public payload: number[]) {}
}

export class DeleteBurstSettingsCompleted implements Action {
  readonly type = ActionTypes.DELETE_BURST_SETTINGS_COMPLETED;

  constructor(
    public isBulk: boolean,
    public response: BulkResponseDataInterface,
  ) {}
}
export class SiteDataLoading implements Action {
  readonly type = ActionTypes.SITES_DATA_LOADING;
}

export class SiteDataCompleted implements Action {
  readonly type = ActionTypes.SITES_DATA_COMPLETED;

  constructor(public payload: (SimplifiedDataInterface & Partial<SiteCRUDInterface>)[]) {}
}
export class LineDataLoading implements Action {
  readonly type = ActionTypes.LINES_DATA_LOADING;

  constructor(public siteId: number) {}
}

export class LineDataCompleted implements Action {
  readonly type = ActionTypes.LINES_DATA_COMPLETED;

  constructor(public payload: GetManyResponseInterface<Partial<LineCRUDInterface>>) {}
}
export class AllLinesDataLoading implements Action {
  readonly type = ActionTypes.ALL_LINES_DATA_LOADING;
}

export class AllLinesDataCompleted implements Action {
  readonly type = ActionTypes.ALL_LINES_DATA_COMPLETED;

  constructor(public payload: GetManyResponseInterface<Partial<LineCRUDInterface>>) {}
}
export class FetchError implements Action {
  readonly type = ActionTypes.FETCH_ERROR;

  constructor(public errorAction: ActionTypes) {}
}

export type BurstSettingActions =
  | BurstSettingsLoading
  | BurstSettingsLoaded
  | GetBurstSetting
  | GetBurstSettingCompleted
  | AddBurstSetting
  | AddBurstSettingCompleted
  | EditBurstSetting
  | EditBurstSettingCompleted
  | DeleteBurstSettings
  | DeleteBurstSettingsCompleted
  | SiteDataLoading
  | SiteDataCompleted
  | LineDataLoading
  | LineDataCompleted
  | AllLinesDataLoading
  | AllLinesDataCompleted
  | FetchError;
